import * as React from 'react';
import classnames from 'classnames';
import { motion } from 'motion/react';
import { MediaQuery, Carousel, SliderCarousel } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import { RecommendationsGalleryMiniCartSection } from './components/restructured/RecommendationsGalleryMiniCartSection/RecommendationsGalleryMiniCartSection.js';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@grandvisionhq/carts-v2';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-utils-react';
import '../ProductBlock/types.js';
import '../ProductBlock/utils/get-variant-images.js';
import '@grandvisionhq/fun-products';
import '../../types.js';
import '@grandvisionhq/api-client';
import { BannerRecommendationContainer } from './components/BannerRecommendationContainer.js';
import { ProductRecommendationContainer } from './components/ProductRecommendationContainer.js';
import { isProductRecommendation } from './utils/guards.js';
import { isValidRecommendation } from './utils/is-valid-recommendation.js';

const RecommendationListMiniCart = ({ labels , recommendations , className ,  })=>{
    const { isRestructuredProductBlockEnabled  } = useFeatureToggles();
    const validRecommendations = recommendations.filter(isValidRecommendation);
    const isPhoneScreen = MediaQuery.useIsPhone();
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const BIG_SCREEN_ITEM_WIDTH = 246;
    const PHONE_SCREEN_ITEM_WIDTH = 186;
    const carouselItems = React.useMemo(()=>{
        if (!validRecommendations) {
            return [];
        }
        const itemsPerSlide = 4;
        const slideCount = Math.ceil(validRecommendations.length / itemsPerSlide);
        const items = [];
        for(let i = 0; i < slideCount; i++){
            const start = i * itemsPerSlide;
            const end = (i + 1) * itemsPerSlide;
            items.push(validRecommendations.slice(start, end).map((recommendation, index)=>isProductRecommendation(recommendation) ? /*#__PURE__*/ React.createElement("div", {
                    className: classnames({
                        'recommendation-list__list-item-slider': !isBigScreen,
                        'recommendation-list__list-item': isBigScreen
                    }),
                    key: `recommendation-${index}`
                }, /*#__PURE__*/ React.createElement(ProductRecommendationContainer, {
                    recommendation: recommendation,
                    position: index + 1
                })) : /*#__PURE__*/ React.createElement("div", {
                    className: classnames({
                        'recommendation-list__list-item-slider': !isBigScreen,
                        'recommendation-list__list-item': isBigScreen
                    }),
                    key: `banner-${index}`
                }, /*#__PURE__*/ React.createElement(BannerRecommendationContainer, {
                    recommendation: recommendation
                }))
            ));
        }
        return items;
    }, [
        validRecommendations,
        isBigScreen
    ]);
    if (!validRecommendations.length) return null;
    if (isRestructuredProductBlockEnabled) {
        return /*#__PURE__*/ React.createElement(RecommendationsGalleryMiniCartSection, {
            title: labels.title,
            recommendations: recommendations
        });
    }
    return /*#__PURE__*/ React.createElement(motion.div, {
        style: {
            overflow: 'hidden'
        },
        variants: {
            start: {
                height: 0
            },
            end: {
                height: 'auto'
            }
        },
        transition: {
            type: 'tween'
        },
        initial: "start",
        animate: "end",
        className: `recommendation-list ${className}`,
        "data-t": "recommendation-list"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "smallest",
        className: "recommendation-list__title"
    }, labels.title), isBigScreen ? /*#__PURE__*/ React.createElement(Carousel, {
        navigationLocation: "top",
        className: "recommendation-list"
    }, carouselItems) : /*#__PURE__*/ React.createElement(SliderCarousel, {
        itemWidth: isPhoneScreen ? PHONE_SCREEN_ITEM_WIDTH : BIG_SCREEN_ITEM_WIDTH
    }, carouselItems));
};

export { RecommendationListMiniCart };
//# sourceMappingURL=RecommendationListMiniCart.js.map
